import { render, staticRenderFns } from "./SinglePodcastView.vue?vue&type=template&id=504277e0&scoped=true&"
import script from "./SinglePodcastView.vue?vue&type=script&lang=js&"
export * from "./SinglePodcastView.vue?vue&type=script&lang=js&"
import style0 from "./SinglePodcastView.vue?vue&type=style&index=0&id=504277e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504277e0",
  null
  
)

export default component.exports